import { render, staticRenderFns } from "./TaskIoForm.vue?vue&type=template&id=8a96b008&scoped=true"
import script from "./TaskIoForm.vue?vue&type=script&lang=js"
export * from "./TaskIoForm.vue?vue&type=script&lang=js"
import style0 from "./TaskIoForm.vue?vue&type=style&index=0&id=8a96b008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a96b008",
  null
  
)

export default component.exports